const ChangedOrder = () => {
    return ( 
        <div className="changedorder">
            <h2>Zamówienie przekazane do kolejnego kroku</h2>
        </div>
     );
}
 
export default ChangedOrder;